// extracted by mini-css-extract-plugin
module.exports = {"landingTopicButton":"landingtopicbutton_landingTopicButton__1wx7x","viewed":"landingtopicbutton_viewed__1Oc7T"};